import './Header.css';

const Header = () => {
  return (
    <div className="header">
        <h1>POPULAR TOUR PLACES</h1>
    </div>
  )
}

export default Header